<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">项目公司</span>
      <div class="action-container">
        <a-button v-if="isAdmin" type="primary" icon="plus" @click="goAdd" class="page-title-btn">
          新建
        </a-button>
      </div>
    </div>
    <div class="content-container">
      <div class="search-container">
        <a-input placeholder="公司名称" v-model="searchParams.companyName" class="medium-search-input">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-input placeholder="资源方名称" v-model="searchParams.partnerName" class="medium-search-input" />
        <a-select
            placeholder="股转完成状态"
            v-model="searchParams.equityReady"
            class="search-select">
          <a-select-option value="">所有状态</a-select-option>
          <a-select-option value="0">未完成</a-select-option>
          <a-select-option value="1">已完成</a-select-option>
        </a-select>
        <a-button
            @click="onSearch"
            class="search-btn"
        >搜索</a-button
        >
      </div>
      <div class="list-container">
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            rowKey="projectId"
            @change="onTableChange"
        >
          <a-space slot="action" slot-scope="record">
            <a v-if="isAdmin" @click="onConfigTeamMember(record, 'auditor')">复核员</a>
            <a v-if="isAdmin" @click="onConfigTeamMember(record, 'riskEvaluator')">风险评估人员</a>
            <a @click="onView(record)">查看</a>
            <a v-if="isAdmin" @click="onEdit(record)">修改</a>
            <a v-if="isAdmin" @click="onDelete(record)" class="danger-text">删除</a>
          </a-space>
        </a-table>
      </div>
    </div>

    <a-modal
        :title="modalTitle"
        :visible="visible"
        :confirm-loading="confirmLoading"
        okText="确定"
        cancelText="取消"
        @ok="handleOk"
        @cancel="handleCancel"
    >
      <a-form :form="form" @submit="handleOk">
        <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
            label="资源合作方"
        >
          <a-select
              v-decorator="[
                'partnerId',
                {
                  rules: [{ required: true, message: '请选择资源合作方' }]
                }
              ]"
              style="width: 100%"
              placeholder="请选择资源合作方"
              :disabled="!isAdmin"
          >
            <a-select-option v-for="item in partnerOptions" :key="item.partnerId" :value="item.partnerId">
              {{ item.partnerName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
            label="公司名称"
        >
          <a-input
              v-decorator="[
                'companyName',
                {
                  rules: [{ required: true, message: '请输入名称' }]
                }
              ]"
          />
        </a-form-item>
        <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
            label="股转完成状态"
            v-if="isAdmin"
        >
          <a-radio-group
              v-decorator="[
                'equityReady',
                {
                  rules: [{ required: true, message: '请选择股转完成状态' }]
                }
              ]">
            <a-radio :value="false">
              未完成
            </a-radio>
            <a-radio :value="true">
              已完成
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      :title="teamMemberModalTitle"
      :visible="configMemberModalVisible"
      :confirm-loading="reviewerConfirmLoading"
      okText="确定"
      cancelText="取消"
      @ok="handleReviewerOk"
      @cancel="configMemberModalVisible=false"
      >
      <div class="field-container">
        <div class="field-label">{{ teamRoleName }}</div>
        <div>
          <a-select
              placeholder="请选择"
              mode="multiple"
              v-model="memberUserIds"
              class="field-input"
          >
            <a-select-option v-for="reviewer in userList" :key="reviewer.userId" :value="reviewer.userId">
              {{ reviewer.realName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import {listOptions} from "@/views/partner/PartnerApi";
import {delCompany, listCompany, saveCompany, loadCompanyTeamMembers, configTeamMembers} from "@/views/company/CompanyApi";
import {isUserAdmin, loadUserPartnerId} from "@/services/UserService";

const tblColumns = [
  {
    title: "公司名称",
    dataIndex: "companyName",
    width: "20%"
  },
  {
    title: "股转完成",
    dataIndex: "equityReadyName",
    width: "10%"
  },
  {
    title: "资源合作方",
    dataIndex: "partnerName",
    width: "10%"
  },
  {
    title: "创建人",
    dataIndex: "createUserName",
    width: "10%"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    width: "20%"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "20%"
  }
];
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 }
};

export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      formItemLayout,
      partnerOptions: [],
      tblData: [],
      searchParams: {
        companyName: "",
        partnerName: "",
        equityReady: ""
      },
      pagination: {
        size: "small",
        showQuickJumper: true
      },
      curCompanyId: "",
      loading: false,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this, { name: "companyForm" }),
      modalTitle: "新增合作方",
      isAdmin: false,
      partnerId: "",
      configMemberModalVisible: false,
      reviewerConfirmLoading: false,
      userList: [],
      memberUserIds: [],
      teamRole: 'auditor',
      teamRoleName: '复核员',
      teamMemberModalTitle: '配置复核员'
    };
  },
  computed: {
  },
  created() {
    listOptions().then(response => {
      if (response.data.code === "SUCCESS") {
        this.partnerOptions = response.data.data;
      }
    });
    isUserAdmin().then(resp => {
      if(resp.data.code === "SUCCESS") {
        this.isAdmin = resp.data.data;
      }
    });
    loadUserPartnerId().then(resp => {
      if(resp.data.code === "SUCCESS") {
        this.partnerId = resp.data.data;
      }
    });
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    onConfigTeamMember(record, teamRoleCode){
      this.memberUserIds = [];
      this.userList = [];
      this.teamRole = teamRoleCode;
      if(teamRoleCode === 'auditor') {
        this.teamRoleName = '复核员';
        this.teamMemberModalTitle = '配置复核员';
      } else {
        this.teamRoleName = '风险评估人员';
        this.teamMemberModalTitle = '配置风险评估人员';
      }
      this.curCompanyId = record.companyId;
      loadCompanyTeamMembers(record.companyId, teamRoleCode).then(resp => {
        if(resp.data.code === "SUCCESS") {
          let rlt = resp.data.data;
          this.memberUserIds = rlt.memberUserIds;
          this.userList = rlt.userList;
          this.configMemberModalVisible = true;
        }
      });
    },
    handleReviewerOk(){
      let params = {
        companyId: this.curCompanyId,
        memberUserIds: this.memberUserIds,
        teamRole: this.teamRole
      }
      configTeamMembers(params).then(resp => {
        if(resp.data.code === "SUCCESS") {
          this.$message.success("设置成功");
          this.configMemberModalVisible = false;
        }
      });
    },
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        ...this.searchParams,
        pageNum,
        pageSize
      };
      listCompany(params)
          .then(response => {
            this.loading = false;
            if (response.data.code === "FAILED") {
              console.log("服务端错误", response.data.errorMsg);
              this.$message.error("读取数据失败");
            } else {
              this.setTblData(response);
            }
          });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
          if(item.equityReady === true) {
            item.equityReadyName = "已完成";
          } else {
            item.equityReadyName = "未完成";
          }
        });
      }
      this.tblData = rltList;
      const pagination = { ...this.pagination };
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },
    goAdd() {
      this.$router.push({ name: "EditCompany", params: { id: "0" } });
    },
    onView(record) {
      this.$router.push({ name: "ViewCompany", params: { id: record.companyId } });
    },
    onEdit(record) {
      this.$router.push({ name: "EditCompany", params: { id: record.companyId } });
    },
    handleOk() {
      this.confirmLoading = true;
      let self = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          values.companyId = self.curCompanyId;
          saveCompany(values).then(response => {
            if (response.data.code === "SUCCESS") {
              self.visible = false;
              self.confirmLoading = false;
              self.form.resetFields();
              self.fetchList();
              self.$message.success("保存成功");
            } else {
              self.confirmLoading = false;
            }
          }).catch(error => {
            this.confirmLoading = false;
            console.log(error);
          });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    onDelete(record) {
      let self = this;
      this.$confirm({
        title: "确定要删除吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          delCompany(record.companyId).then(resp => {
            if (resp.data.code === "SUCCESS") {
              self.$message.success("删除成功");
              self.fetchList();
            }
          });
        }
      });
    },
  }
};
</script>

<style scoped>
.field-container {
  display: flex;
  align-items: center;
}
.field-label {
  min-width: 100px;
}
.field-input {
  min-width: 220px;
}
</style>
